const enumToArray = <T extends Record<string, unknown>>(
  givenEnum: T,
) => Object.keys(givenEnum).map((key) => {
    const keyValue = key as keyof typeof givenEnum;
    return ({
      key: keyValue,
      value: givenEnum[keyValue],
    });
  });

export default enumToArray;
